/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_State_OverdueInputs */

const vi_station_work_state_overdue = /** @type {(inputs: Station_Work_State_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quá hạn`)
};

/**

* @param {Station_Work_State_OverdueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_state_overdue = /** @type {((inputs?: Station_Work_State_OverdueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_State_OverdueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_state_overdue(inputs)
});